<div class="maintenance-modal" *ngIf="isMaintenanceModeOn">
  <img
    class="header"
    src="https://qnw506.files.keap.app/qnw506/7b35c7e0-33d6-40af-ab4f-3c52dd7f2971"
  />
  <div class="content">
    <div class="title">Scheduled Maintenance</div>
    <div class="description">
      We’re performing scheduled maintenance to deploy improvements and
      enhancements designed to increase performance and support future
      development.

      <br />
      <p style="">
        <span style="color: rgb(185, 106, 217) !important"
          ><strong>Maintenance Schedule:</strong></span
        >
      </p>
      Date:
      <strong style="color: rgb(241, 196, 15) !important"
        >January 7, 2026</strong
      >
      <br />
      Time:
      <strong style="color: rgb(241, 196, 15) !important"
        >4:30 AM to 8:30 AM (PST)</strong
      >

      <br />
      <p style="">
        <span style="color: rgb(185, 106, 217) !important"
          ><strong>Impact on Services:</strong></span
        >
      </p>

      During this period, the site and app may be temporarily unavailable. We
      appreciate your patience as we work to improve your experience.
      <br />

      <p style="">
        <span style="color: rgb(185, 106, 217) !important"
          ><strong>What to Expect After Maintenance:</strong></span
        >
      </p>

      <ul>
        <li>
          <strong>New and improved dashboard</strong> — enhanced usability and
          clarity.
        </li>
        <li>
          <strong>System updates</strong> — infrastructure improvements to support
          upcoming features.
        </li>
      </ul>

      <p style="">
        <span style="color: rgb(185, 106, 217) !important"
          ><strong>Post-Maintenance Login Guidance:</strong></span
        >
      </p>

      If you encounter any login issues after maintenance concludes, please use
      the <strong>Forgot Password</strong> function to change your password —
      this resolves most login-related problems.
      <br />
      <div class="footer">
        **If the issue persists or you experience any other difficulties, our
        support team is ready to assist at
        <strong
          ><a
            href="mailto:support@destcert.com"
            style="color: rgb(185, 106, 217)"
            >support&#64;destcert.com</a
          >&nbsp;</strong
        >
      </div>
    </div>
  </div>
</div>